module.exports = __webpack_public_path__ + "img/volunteer.3f655297.png";